/* ============================================================
   buddy-a-blog.js — Blog Technisch-Clean, client-seitige Logik
   für das buddy-a-Section-System (Header + n Kapitel-Sections).

   Da Liquid-Sections einander nicht sehen, generiert dieses JS die
   Nav-Pills + Kapitel-Nummern aus den gerenderten .buddy-a-chapter-
   Elementen. Portiert + erweitert aus dem alten theme.liquid-Blog-JS.
   ============================================================ */
(function () {
  // Doppel-Init-Schutz (z.B. wenn Section im Theme-Editor neu lädt)
  if (window.__btcInit) return;
  // Guard: nur auf buddy-a-Header-Seiten aktiv werden
  if (!document.querySelector('.blog-tc--header')) return;
  window.__btcInit = true;

  // Kategorie → CSS-Klasse (analog buddy-a-header.liquid / BLOG-LISTING-SYSTEM.md)
  var catMap = {
    'aktuelles & aktionen': 'aktuelles',
    'aktion': 'aktuelles',
    'ratgeber': 'ratgeber',
    'kaufberatung': 'kaufberatung',
    'montage': 'montage',
    'produktwissen': 'produktwissen'
  };

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  // ----------------------------------------------------------
  // 1. Nav-Generierung aus .buddy-a-chapter + Kapitel-Nummern
  // ----------------------------------------------------------
  (function () {
    var navInner = document.querySelector('.blog-tc--header .chapter-nav-inner');
    if (!navInner) return;

    var chapters = document.querySelectorAll('.buddy-a-chapter');
    var num = 0;

    chapters.forEach(function (chapter, idx) {
      var id = chapter.id;
      if (!id) {
        id = 'buddy-a-chapter-' + (idx + 1);
        chapter.id = id;
      }

      var title = chapter.getAttribute('data-chapter-title') || '';
      var unnumbered = chapter.hasAttribute('data-nav-unnumbered');

      var pill = document.createElement('a');
      pill.className = 'nav-pill';
      pill.href = '#' + id;
      pill.setAttribute('data-section', id);
      if (idx === 0) pill.classList.add('active');

      if (!unnumbered) {
        num += 1;
        var numLabel = pad2(num);
        var numSpan = document.createElement('span');
        numSpan.className = 'nav-pill-num';
        numSpan.textContent = numLabel;
        pill.appendChild(numSpan);
        pill.appendChild(document.createTextNode(' ' + title));

        // Platzhalter {N} in der Kapitel-Section-Nummer ersetzen
        var autoNumEls = chapter.querySelectorAll('.section-number[data-auto-num]');
        autoNumEls.forEach(function (el) {
          el.textContent = el.textContent.replace('{N}', numLabel);
        });
      } else {
        pill.appendChild(document.createTextNode(title));

        // Unnummeriertes Kapitel: kein "Kapitel {N}"-Eyebrow. Den Default-Kicker mit
        // unersetztem {N}-Platzhalter ausblenden; benutzerdefinierte Kicker (ohne {N})
        // bleiben sichtbar (z. B. "Bonus").
        var unnumLabelEls = chapter.querySelectorAll('.section-number[data-auto-num]');
        unnumLabelEls.forEach(function (el) {
          if (el.textContent.indexOf('{N}') !== -1) { el.style.display = 'none'; }
        });
      }

      navInner.appendChild(pill);
    });
  })();

  // ----------------------------------------------------------
  // 2. Breadcrumb-Teil (Back-Link + Kategorie-Pill + Trennlinie)
  //    VOR den Kapitel-Pills einfügen
  // ----------------------------------------------------------
  (function () {
    var nav = document.getElementById('chapter-nav');
    var navInner = document.querySelector('.blog-tc--header .chapter-nav-inner');
    if (!nav || !navInner) return;

    var blogUrl = nav.getAttribute('data-blog-url') || '';
    var tag = nav.getAttribute('data-category') || '';
    if (!tag) return;

    var tagLower = tag.toLowerCase();
    var catClass = catMap[tagLower] || 'ratgeber';
    var tagHandle = tagLower.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

    // Back-Link
    var backLink = document.createElement('a');
    backLink.className = 'bl-nav-back';
    backLink.href = blogUrl;
    backLink.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg><span>Blog</span>';

    // Kategorie-Pill
    var catPill = document.createElement('a');
    catPill.className = 'bl-nav-cat bl-nav-cat--' + catClass;
    catPill.href = blogUrl + '/tagged/' + tagHandle;
    catPill.textContent = tag;

    // Trennlinie
    var divider = document.createElement('div');
    divider.className = 'bl-nav-divider';

    // Crumbs-Wrapper (Variante A 2026-07-17): Back-Link + Kategorie-Pill +
    // Trennlinie kleben als Block sticky links im Scroll-Track, die Kapitel-
    // Pills laufen dahinter durch (CSS: .bl-nav-crumbs in blog-tc.css)
    var crumbs = document.createElement('span');
    crumbs.className = 'bl-nav-crumbs';
    crumbs.appendChild(backLink);
    crumbs.appendChild(catPill);
    crumbs.appendChild(divider);
    navInner.insertBefore(crumbs, navInner.firstChild);
  })();

  // ----------------------------------------------------------
  // 3. Reading Progress Bar
  // ----------------------------------------------------------
  (function () {
    var bar = document.getElementById('progress-bar');
    if (!bar) return;

    function updateProgress() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = Math.min(progress, 100) + '%';
      bar.setAttribute('aria-valuenow', Math.round(progress));
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  })();

  // ----------------------------------------------------------
  // 4. Pinned Nav: JS-gesteuert fixed statt CSS sticky (mit Spacer)
  // ----------------------------------------------------------
  (function () {
    var nav = document.getElementById('chapter-nav');
    if (!nav) return;

    // Spacer einfügen (verhindert Content-Sprung beim Pinnen)
    var spacer = document.createElement('div');
    spacer.className = 'nav-spacer';
    nav.parentNode.insertBefore(spacer, nav.nextSibling);

    function computeNavOriginalTop() {
      return nav.offsetTop + nav.closest('.blog-tc').getBoundingClientRect().top + window.scrollY;
    }

    var navOriginalTop = computeNavOriginalTop();
    var isPinned = false;
    var headerBottomCache = null; // I-1: getHeaderBottom-Ergebnis cachen, bei resize invalidieren

    function getHeaderBottom() {
      if (headerBottomCache !== null) return headerBottomCache;
      var selectors = [
        '.shopify-section-group-header-group',
        '#shopify-section-header',
        '[data-section-type="header"]',
        '.header-wrapper',
        'header'
      ];
      var result = 4; // Fallback: nur Progress-Bar-Höhe
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el) {
          var style = window.getComputedStyle(el);
          if (style.position === 'fixed' || style.position === 'sticky') {
            var bottom = el.getBoundingClientRect().bottom;
            if (bottom > 0) { result = bottom; break; }
          }
        }
      }
      headerBottomCache = result;
      return result;
    }

    function updatePin() {
      var scrollY = window.scrollY;
      var topOffset = getHeaderBottom();

      if (scrollY > navOriginalTop - topOffset) {
        if (!isPinned) {
          spacer.style.display = 'block';
          spacer.style.height = nav.offsetHeight + 'px';
          nav.classList.add('is-pinned');
          isPinned = true;
        }
        nav.style.top = topOffset + 'px';
      } else {
        if (isPinned) {
          spacer.style.display = 'none';
          nav.classList.remove('is-pinned');
          nav.style.top = '';
          isPinned = false;
        }
      }
    }

    window.addEventListener('resize', function () {
      headerBottomCache = null; // I-1: gecachte Header-Höhe verwerfen
      if (isPinned) {
        nav.classList.remove('is-pinned');
        spacer.style.display = 'none';
        isPinned = false;
        nav.style.top = '';
      }
      navOriginalTop = computeNavOriginalTop();
      updatePin();
    });

    // M-2: nachladende Bilder verschieben das Layout — navOriginalTop neu messen
    window.addEventListener('load', function () {
      navOriginalTop = computeNavOriginalTop();
      updatePin();
    });

    window.addEventListener('scroll', updatePin, { passive: true });
    updatePin();
  })();

  // ----------------------------------------------------------
  // 5. Active Nav Pill on Scroll (scroll-margin-top: 80px beachtet)
  // ----------------------------------------------------------
  (function () {
    var pills = document.querySelectorAll('.blog-tc .nav-pill[data-section]');
    var sections = [];

    pills.forEach(function (pill) {
      var id = pill.getAttribute('data-section');
      var el = document.getElementById(id);
      if (el) {
        sections.push({ pill: pill, el: el });
      }
    });

    if (!sections.length) return;

    var nav = document.getElementById('chapter-nav');
    var lastActivePill = null; // I-3: Zentrierung nur bei tatsächlichem Wechsel
    var navInner = document.querySelector('.blog-tc--header .chapter-nav-inner');

    // Variante A (2026-07-17): aktive Pill mittig in die SICHTBARE Flaeche
    // fahren (rechts vom sticky .bl-nav-crumbs-Block). Bewusst kein
    // scrollIntoView — das wuerde vertikal die Seite mitscrollen.
    function centerPill(pill) {
      if (!navInner || navInner.scrollWidth <= navInner.clientWidth + 4) return;
      var crumbsEl = navInner.querySelector('.bl-nav-crumbs');
      var cw = crumbsEl ? crumbsEl.getBoundingClientRect().width : 0;
      var innerRect = navInner.getBoundingClientRect();
      var pillRect = pill.getBoundingClientRect();
      var pillLeft = pillRect.left - innerRect.left + navInner.scrollLeft;
      var visible = navInner.clientWidth - cw;
      var target = pillLeft - cw - visible / 2 + pillRect.width / 2;
      var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      navInner.scrollTo({ left: Math.max(0, target), behavior: motionOk ? 'smooth' : 'auto' });
    }

    // I-2: dokument-relative Kapitel-Offsets einmalig cachen,
    // bei resize/load neu berechnen statt pro Scroll-Frame zu messen.
    // navBottom wird pro Frame live gelesen (ändert sich mit Pinning-Zustand).
    var sectionTopsCache = [];

    function recomputeOffsets() {
      sectionTopsCache = sections.map(function (s) {
        return s.el.getBoundingClientRect().top + window.scrollY;
      });
    }

    function getActiveSection() {
      var navBottom = nav ? nav.getBoundingClientRect().bottom : 60;
      var threshold = window.scrollY + navBottom + 20;
      var active = null;
      for (var i = 0; i < sections.length; i++) {
        if (threshold >= sectionTopsCache[i]) {
          active = sections[i];
        }
      }
      // F6: oberhalb des ersten Kapitels (Seitenanfang) bleibt die erste Pill aktiv,
      // statt gar keine Pill zu markieren.
      if (!active) active = sections[0];
      return active;
    }

    function updateNav() {
      var active = getActiveSection();
      pills.forEach(function (p) { p.classList.remove('active'); });
      if (active) {
        active.pill.classList.add('active');
        if (active.pill !== lastActivePill) {
          centerPill(active.pill);
          lastActivePill = active.pill;
        }
      } else {
        lastActivePill = null;
      }
    }

    recomputeOffsets();
    window.addEventListener('resize', function () { recomputeOffsets(); updateNav(); });
    window.addEventListener('load', function () { recomputeOffsets(); updateNav(); });
    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  })();

  // ----------------------------------------------------------
  // 6. Scroll-Track (Variante A 2026-07-17): Fade-Kante rechts
  //    am Track-Ende ausblenden + Mausrad → horizontal scrollen
  // ----------------------------------------------------------
  (function () {
    var nav = document.getElementById('chapter-nav');
    var navInner = document.querySelector('.blog-tc--header .chapter-nav-inner');
    if (!nav || !navInner) return;

    function updateEdges() {
      var overflows = navInner.scrollWidth > navInner.clientWidth + 4;
      var atEnd = !overflows ||
        navInner.scrollLeft + navInner.clientWidth >= navInner.scrollWidth - 4;
      nav.classList.toggle('nav-at-end', atEnd);
    }

    navInner.addEventListener('scroll', updateEdges, { passive: true });
    window.addEventListener('resize', updateEdges);
    window.addEventListener('load', updateEdges);
    updateEdges();

    // Desktop-Maus ohne Trackpad: vertikales Rad ueber der Leiste scrollt
    // den Track horizontal. Trackpad-Gesten (deltaX dominant) bleiben
    // unangetastet, ohne Overflow greift das normale Seiten-Scrollen.
    navInner.addEventListener('wheel', function (e) {
      if (navInner.scrollWidth <= navInner.clientWidth + 4) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      e.preventDefault();
      navInner.scrollLeft += e.deltaY;
    }, { passive: false });
  })();

})();
